module.exports = __webpack_public_path__ + "static/media/web.c438282f.config";